import { QSWidgetTypes } from './interfaces';

export const quinnWidgetMarker = '<div id="quinn"></div>';

export interface IWidgetData {
  src: (params: Record<string, string>) => string;
  mainId: string;
  widgetContainerId: string;
  styles: string;
  config: Record<string, string>;
  brow?: string;
  title?: string;
}

export function getWidgetType(pc: string): 'crm' | 'sem' | null {
  if (pc) {
    if (pc.includes('crm_exp')) return 'crm';
    if (pc.includes('sem_exp')) return 'sem';
  }
  return null;
}

export const stylesWidgetContainer =
  '#qsWidgetContainer >div{background:none !important; padding:0 !important} #qsWidgetContainer .sh-listing-container{padding:0 !important}';

export const widgetConfiguration: Record<QSWidgetTypes, IWidgetData> = {
  highyield: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'sem') {
          if (
            params.cc &&
            (params.cc.includes('_21441055405_') || params.cc.includes('_21441055408_'))
          ) {
            return '692791';
          }
          return '692609';
        }
        if (type === 'crm') {
          if (params.st && params.st === 'sub') {
            return '692169';
          }
          return '691741';
        }
      }
      return '691523';
    },
    mainId: '',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'vps10-incontent',
      bankingrateproducttypes: 'MMA,Savings'
    },
    brow: 'Earn Money Faster',
    title: 'Find High-Yield Savings Accounts'
  },
  mma: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        if (getWidgetType(params.pc) === 'crm') {
          return '691741';
        }
      }
      return '693643';
    },
    mainId: '',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'vps10-incontent',
      bankingrateproducttypes: 'MMA,Savings'
    },
    brow: 'Earn Money Faster',
    title: 'Find Money Market Accounts'
  },
  cd: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'crm') {
          return '692792';
        }
        if (type === 'sem') {
          if (params.cc && params.cc.includes('_21437125895_')) {
            return '693639';
          }
          return '691807';
        }
      }
      return '691806';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '3',
      inventorytype: 'valueprops10_cd-incontent',
      zipcode: '',
      all_products: '1'
    },
    brow: 'Earn Money Faster',
    title: 'Find High-Yield CDs'
  },
  investing: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'crm') {
          return '691809';
        }
      }
      return '691808';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'vps10-incontent',
      bankingrateproducttypes:
        'Annuity, Brokerage, Robo Advisor, Financial Advisor, REIT, Stock Trading, Crypto, Roth IRA, Traditional IRA, 401k, Tax-loss harvesting'
    },
    brow: 'Invest Your Money Smarter',
    title: 'Browse Top Brokerages'
  },
  checking: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'sem') {
          return '691805';
        }
      }
      return '691804';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'vps10-incontent',
      bankingrateproducttypes: 'Checking'
    },
    brow: 'Manage Your Finances',
    title: 'Find Digital Checking Accounts'
  },
  business_checking: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'crm') {
          return '691811';
        }
      }
      return '691810';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'vps10-incontent',
      bankingrateproducttypes: 'Business Checking'
    },
    brow: 'Manage Your Business Finances',
    title: 'Find Business Checking Accounts'
  },
  annuity: {
    src: function (params: Record<string, string>) {
      if (params.pc) {
        const type = getWidgetType(params.pc);
        if (type === 'sem') {
          return '692788';
        }
      }
      return '692790';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: stylesWidgetContainer,
    config: {
      var1: '',
      var2: '',
      var3: '',
      trn_id: '',
      rp: '17',
      inventorytype: 'valueprops-incontent',
      bankingrateproducttypes: 'Annuity'
    },
    brow: 'SECURE YOUR RETIREMENT',
    title: 'Find Annuities'
  },
  auto_insurance: {
    src: function () {
      return '692120';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: '',
    config: {
      zipcode: '',
      statecode: '',
      var1: process.env.NODE_ENV === 'production' ? '' : 'QA.Test',
      var2: '',
      var3: '',
      trn_id: 'transactionId',
      leadid: '',
      activelicense: '',
      age: '',
      carrier: 'Other',
      creditrating: '',
      currentlyinsured: '',
      drivercount: '',
      dui: '',
      education: '',
      gender: '',
      homeowner: '',
      married: '',
      military: '',
      occupation: '',
      recentincidentcount: '',
      sr22: '0',
      suspension: '',
      vehiclecount: '',
      primary_color: '#2a5595',
      button_hover_color: '#4B67A2',
      button_font_color: '#ffffff',
      inventorytype: 'generic-listing-incontent'
    }
  },
  home_insurance: {
    src: function () {
      return '692121';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: '',
    config: {
      zipcode: '',
      statecode: '',
      var1: process.env.NODE_ENV === 'production' ? '' : 'QA.Test',
      var2: '',
      var3: '',
      trn_id: 'transactionId',
      leadid: '',
      activelicense: '',
      age: '',
      carrier: 'Other',
      creditrating: '',
      currentlyinsured: '',
      drivercount: '',
      dui: '',
      education: '',
      gender: '',
      homeowner: '',
      married: '',
      military: '',
      occupation: '',
      recentincidentcount: '',
      sr22: '0',
      suspension: '',
      vehiclecount: '',
      primary_color: '#2a5595',
      button_hover_color: '#4B67A2',
      button_font_color: '#ffffff',
      inventorytype: 'generic-home-incontent'
    }
  },
  life_insurance: {
    src: function (params: Record<string, string>) {
      const type = getWidgetType(params.pc);
      if (type === 'sem') {
        return '693584';
      }
      return '692562';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: '',
    config: {
      inventorytype: 'generic-life-incontent',
      originwidgetinstanceid: '',
      zipcode: '',
      statecode: '',
      var1: process.env.NODE_ENV === 'production' ? '' : 'QA.Test',
      var2: '',
      var3: '',
      trn_id: 'transactionId',
      leadid: '',
      age: '',
      carrier: '',
      creditrating: '',
      currentlyinsured: '',
      dui: '',
      education: '',
      gender: '',
      homeowner: '',
      married: '',
      military: '',
      occupation: '',
      hazardousoccupation: '',
      medicalcondition: '',
      height: '',
      weight: '',
      tobacco: '',
      session_ref: '',
      lp_url: '',
      ext_click_id: '',
      primary_color: '#2a5595',
      button_hover_color: '#4B67A2',
      button_font_color: '#ffffff'
    }
  },
  pet_insurance: {
    src: function (params: Record<string, string>) {
      const type = getWidgetType(params.pc);
      if (type === 'sem') {
        return '693578';
      }
      if (type === 'crm') {
        return '693576';
      }
      return '693577';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: `
     #qSavGE {padding:1px 0 30px;}@media only screen and (max-width: 650px) {#qSavGE {padding:1px 0 20px;}}
    `,
    config: {
      inventorytype: '',
      originwidgetinstanceid: '',
      zipcode: '',
      statecode: '',
      var1: process.env.NODE_ENV === 'production' ? '' : 'QA.Test',
      var2: '',
      var3: '',
      trn_id: 'transactionId',
      leadid: '',
      petage: '3 years',
      petgender: 'male',
      petcount: '1',
      pettype: 'dog',
      session_ref: '',
      lp_url: '',
      ext_click_id: ''
    }
  },
  rental_insurance: {
    src: function () {
      return '694601';
    },
    mainId: 'qSavGE',
    widgetContainerId: 'qsWidgetContainer',
    styles: `
     #qSavGE {padding:30px 0;}@media only screen and (max-width: 650px) {#qSavGE {padding:20px 0;}}
    `,
    config: {
      inventorytype: 'generic-home-incontent',
      var1: process.env.NODE_ENV === 'production' ? '' : 'QA.Test',
      var2: '',
      var3: '',
      trn_id: 'transactionId'
    }
  }
};
